import React, { PureComponent } from 'react';

import { message as AntMessage, Popconfirm as AntPopconfirm } from 'antd';
import { services } from '@comall-backend-builder/core';
import { Button } from '@comall-backend-builder/components-basis';
import { errorHandle } from '../../services';

const api = services.api;
/**
 * 直播商品列表页 操作按钮
 */
export class LiveProductActionButton extends PureComponent<any, any> {
    
    refresh = () => {
        const { entity, row: { id } } = this.props;
        api.get(
            {},
            { apiPath: `/live/products/refresh/${id}` }
        ).then(() => {
            AntMessage.success('刷新成功');

            // 列表数据刷新
            entity.search({
                ...entity.params,
                ...entity.filters,
            });
        })
        .catch(errorHandle);
    }

    renderRefreshBtn() {
        const btnProps = {
            text: '刷新',
            onClick: this.refresh
        };
        return (
            <Button {...btnProps} type='link' />
        );
    }

    delete = () => {
        const { entity, row: { id } } = this.props;
        api.delete(
            {},
            { apiPath: `/live/products/${id}` }
        ).then(() => {
            AntMessage.success('删除成功');

            // 列表数据刷新
            entity.search({
                ...entity.params,
                ...entity.filters,
            });
        })
        .catch(errorHandle);
    }

    renderDeleteBtn() {
        const confirmProps = {
            title: '确定要删除吗？',
            okText: '确定',
            cancelText: '取消',
            onConfirm: this.delete,
        };
        const btnProps = {
            text: '删除',
        };
        return (
            <AntPopconfirm {...confirmProps}>
                <Button {...btnProps} type='link' />
            </AntPopconfirm>
        );
    }

    modify = () => {
        const { row: { id } } = this.props;
        services.navigation.goto(`/live-product/modify/${id}`);
    }

    renderModifyBtn() {
        const btnProps = {
            text: '编辑',
            style: {
                marginRight: 10
            },
            onClick: this.modify
        };
        return (
            <Button {...btnProps} type='link' />
        );
    }
    
    render() {
        const { row: { status } } = this.props;

        let btnElement;
        if (status === 'UNDER_REVIEW') {
            btnElement = <div>{this.renderRefreshBtn()}</div>;
        } else if (status === 'APPROVED') {
            btnElement = <div>
                {this.renderModifyBtn()}
                {this.renderDeleteBtn()}
            </div>;
        } else if (status === 'REJECTION') {
            btnElement = <div>{this.renderDeleteBtn()}</div>;
        }
        
        return btnElement;
    }
}
